var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 2H20C21.1046 2 22 2.89543 22 4V16C22 17.1046 21.1046 18 20 18H19V8C19 5.79086 17.2091 4 15 4L7 4C7 2.89543 7.89543 2 9 2ZM9 0C6.79086 0 5 1.79086 5 4L4 4C1.79086 4 0 5.79086 0 8V20C0 22.2091 1.79086 24 4 24H15C17.2091 24 19 22.2091 19 20H20C22.2091 20 24 18.2091 24 16V4C24 1.79086 22.2091 0 20 0H9ZM15 6H4C2.89543 6 2 6.89543 2 8V20C2 21.1046 2.89543 22 4 22H15C16.1046 22 17 21.1046 17 20V8C17 6.89543 16.1046 6 15 6ZM6 8C5.44772 8 5 8.44771 5 9C5 9.55229 5.44772 10 6 10H10C10.5523 10 11 9.55229 11 9C11 8.44771 10.5523 8 10 8H6ZM5 18C5 17.4477 5.44772 17 6 17H10C10.5523 17 11 17.4477 11 18C11 18.5523 10.5523 19 10 19H6C5.44772 19 5 18.5523 5 18ZM6 12C5.44772 12 5 12.4477 5 13C5 13.5523 5.44772 14 6 14H13C13.5523 14 14 13.5523 14 13C14 12.4477 13.5523 12 13 12H6Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copy_icon.803c7efc8f2544cf553b22c898429a6a.svg";
export { ForwardRef as ReactComponent };